import React from 'react'
import { Container } from '@kogk/common'
import { CardDetailsType } from '..'
import { useFlickity } from '../utils/useFlickity'
import cn from 'classnames'
import { FlickityOptions } from 'react-flickity-component'

export const SliderHeader: React.FC<{
  title: string
}> = ({ title, children }) => {
  return (
    <Container className='p-1 p-lg-0 mb-2 mb-lg-3'>
      <div className='slider__header d-flex justify-content-between'>
        <div className='d-flex'>
          <h3>{title}</h3>
        </div>
        <div className='d-none d-lg-block'>{children}</div>
      </div>
    </Container>
  )
}

const Footer: React.FC = ({ children }) => {
  return (
    <Container className='w-100 d-flex justify-content-between p-1 p-lg-0'>
      <div className='d-block d-lg-none'>{children}</div>
      <span />
    </Container>
  )
}

const Slider: React.FC<{
  cards: CardDetailsType[]
  onRender: (item: CardDetailsType, idx: number) => React.ReactNode
  title: string
  visibleCards?: number
  onRenderLink?: () => JSX.Element
  flickityOptions?: FlickityOptions
}> = ({ cards, onRender, title, onRenderLink, visibleCards = 4, flickityOptions = {} }) => {
  const { successfulLoad } = useFlickity('.slider', {
    initialIndex: 0,
    contain: true,
    cellAlign: 'left',
    ...flickityOptions
  })

  return (
    <Container className='page-slice-spacer position-relative slider__container'>
      <SliderHeader title={title}>{onRenderLink && onRenderLink()}</SliderHeader>
      <div
        className={cn('slider', {
          'slide--loading': !successfulLoad,
          'slider--hide-btns': cards.length <= visibleCards
        })}
      >
        {cards && cards.map((card, idx) => onRender(card, idx))}
      </div>
      <Footer>{onRenderLink && onRenderLink()}</Footer>
    </Container>
  )
}

export default Slider
